import PropTypes from 'prop-types';

// PropTypes for Layout components
export const LayoutPropTypes = {
  // Base Layout Props
  layout: {
    children: PropTypes.node.isRequired,
    title: PropTypes.string,
    subtitle: PropTypes.string,
    className: PropTypes.string,
    maxWidth: PropTypes.string,
    showFooter: PropTypes.bool
  },

  // Auth Layout Props
  authLayout: {
    children: PropTypes.node.isRequired,
    title: PropTypes.string,
    subtitle: PropTypes.string,
    alert: PropTypes.shape({
      type: PropTypes.oneOf(['success', 'error', 'warning', 'info']).isRequired,
      message: PropTypes.string.isRequired
    }),
    onAlertClose: PropTypes.func,
    maxWidth: PropTypes.string,
    showFooter: PropTypes.bool
  },

  // Page Layout Props
  pageLayout: {
    children: PropTypes.node.isRequired,
    header: PropTypes.node,
    className: PropTypes.string,
    containerMaxWidth: PropTypes.string,
    mainMaxWidth: PropTypes.string,
    showHeader: PropTypes.bool
  },

  // Main Layout Props
  mainLayout: {
    children: PropTypes.node.isRequired,
    topBarProps: PropTypes.object,
    showTopBar: PropTypes.bool,
    className: PropTypes.string,
    containerMaxWidth: PropTypes.string,
    mainMaxWidth: PropTypes.string
  }
};

// Default props
export const LayoutDefaultProps = {
  layout: {
    className: '',
    showFooter: true
  },
  
  authLayout: {
    showFooter: true
  },
  
  pageLayout: {
    className: '',
    showHeader: true
  },
  
  mainLayout: {
    topBarProps: {},
    showTopBar: true,
    className: ''
  }
};
